import { cn } from "@/shared/helpers/cn.helper";

import Typography from "../typography/typography";

export const TableHead: React.FC<React.ComponentProps<"th">> = ({
  className,
  ...props
}) => {
  return (
    <th
      className={cn(
        "text-foreground h-10 whitespace-nowrap border-b border-r border-border-2 px-2 text-left align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        Typography.classes.Title.default,
        Typography.classes.Title.classnames.tableTitleS,
        "text-text-tertiary",
        className,
      )}
      data-slot="table-head"
      {...props}
    />
  );
};
